import { invalidateAutomationDetails } from '../Reports/useAutomationDetails';
import { invalidateAutomationReports } from '../Reports/useInfiniteAutomationReportsQuery';
import { invalidateAllUpcomingAutomationEmailsQueries } from '../Reports/useInfiniteUpcomingAutomationEmailsQuery';
import { invalidateAllAutomationQueries } from './queries/useAutomationQuery';
import { invalidateAllContactAutomationsQueries } from './queries/useContactAutomationsQuery';

/**
 * One step surfaces on the contact banner, the automation detail view, both reporting tables and the
 * upcoming-emails campaign table — which buckets rows by due date, so an edit moves a row between
 * groups. Editing or cancelling a step has to refresh all five families; whichever is missed keeps
 * rendering the old value until the page is reloaded.
 */
export function invalidateAutomationStepQueries() {
	invalidateAllAutomationQueries();
	invalidateAllContactAutomationsQueries();
	invalidateAutomationReports();
	invalidateAutomationDetails();
	invalidateAllUpcomingAutomationEmailsQueries();
}
